import pageRequest from '@/store/models/page-request'

export default class SchoolInput extends pageRequest {
    schoolName?: any | null
}